import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Support from './pages/Support';
import DataDeletion from './pages/DataDeletion';
import Admin from './pages/Admin';
import AuthAction from './pages/AuthAction';

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const isStandalone = location.pathname.startsWith('/auth-action');

  return (
    <>
      {!isAdmin && !isStandalone && (
        <nav className="navbar">
          <div className="container navbar-content">
            <Link to="/" className="logo">
              <img src="/new-icon-fxp.png" alt="Flow XP" className="logo-image" />
            </Link>
            <div className="nav-links">
              <Link to="/">Home</Link>
              <Link to="/support">Support</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms">Terms</Link>
            </div>
          </div>
        </nav>
      )}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/support" element={<Support />} />
        <Route path="/data-deletion" element={<DataDeletion />} />
        <Route path="/auth-action" element={<AuthAction />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>

      {!isAdmin && !isStandalone && (
        <footer className="footer">
          <div className="container">
            <p>&copy; 2026 Flow XP by Flowledge. All rights reserved.</p>
            <div className="footer-links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms & Conditions</Link>
              <Link to="/support">Support</Link>
              <Link to="/data-deletion">Data Deletion</Link>
            </div>
          </div>
        </footer>
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
